"use client";

import Link from "next/link";
import { motion } from "framer-motion";

export default function FinalCta() {
  const buttonContainerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1, delayChildren: 0.35 } },
  };
  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 12 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { type: "spring" as const, stiffness: 280, damping: 20 } },
  };

  return (
    <section id="cta" className="bg-primary py-24 px-4">
      <div className="container mx-auto max-w-3xl text-center">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-center text-primary-foreground"
          initial={{ opacity: 0, y: -20, scale: 0.95 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, type: "spring", stiffness: 200, damping: 22 }}
        >
          Ready to start building smarter money habits?
        </motion.h2>

        <motion.div
          className="flex gap-4 justify-center flex-wrap mt-8"
          variants={buttonContainerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div
            variants={buttonVariants}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <Link
              href="/register"
              className="bg-white text-foreground hover:bg-white/90 rounded-full px-6 py-2 text-sm font-medium hover:shadow-md transition-all duration-150"
            >
              Register
            </Link>
          </motion.div>
          <motion.div
            variants={buttonVariants}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <Link
              href="/login"
              className="border border-white text-white bg-transparent hover:bg-white/20 rounded-full px-6 py-2 text-sm font-medium transition-all duration-150"
            >
              Log In
            </Link>
          </motion.div>
        </motion.div>

      </div>
    </section>
  );
}
